import { $api } from "./axios.service";

export class PaymentService {
  static perfectMoneyInfo(id) {
    return $api.get("/api/front/payment/perfectMoney", { params: { id } });
  }
}